import { useContext, MouseEvent, useState, useEffect } from "react";
import { Card, Button, Typography, Tooltip } from "antd";
import { HeartOutlined, HeartFilled } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { GetGrantByIdAPI, UpdateGrantsFavAPI } from "../../../API/GrantsAPI";
import { IResponseProps } from "../../../Interfaces/IResponseProps";
import './styles.css';
import { CompanyContext } from "../../../Contexts/CompanyContext";
import { AuthContext } from "../../../Contexts/AuthContext";
import { IFormItemsRefundablePut } from "../../../antd/pages/register/refundable";
import { IFormItemsSubventionPut } from "../../../antd/pages/register/subvention";

const { Text } = Typography;

const LinesCard = (props: any) => {
    const { company } = useContext(CompanyContext);
    const { userEmail } = useContext(AuthContext);
    const [tax, setTax] = useState<string>("");
    const isFav = props.isFav;
    const [favorite, setFavorite] = useState(isFav);
    const [grantRefundable, setGrantRefundable] = useState<(IFormItemsRefundablePut)>();
    const [grantSubvention, setGrantSubvention] = useState<(IFormItemsSubventionPut )>();
    const [grants, setGrants] = useState<any>({})

    const updateFav = async (e: MouseEvent) => {
        e.stopPropagation();
        props.toggleLoading(true);
        try {
           var value : any = await getFinancingLine();
           
            let resp : IResponseProps
            if(props.typeOfFinancing == 1){
                
                if(value != undefined){
                    resp = await UpdateGrantsFavAPI(
                        props.id.toString(),
                        company.id,
                        props.title,
                        userEmail,
                        props.bankName,
                        value.summary
                    );

                    if ( resp.statusCode === 200) {
                        setFavorite(!favorite);
                        window.location.reload();
                    }
                }
            }else{
                
            
                if(value != undefined){
                    resp = await UpdateGrantsFavAPI(
                        props.id.toString(),
                        company.id,
                        props.title,
                        userEmail,
                        props.bankName,
                        value.goal
                
                );
                if ( resp.statusCode === 200) {
                    setFavorite(!favorite);
                    window.location.reload();
                }
            }
            }          
            
        } catch (error: any) {
            toast.error(error.message || "Erro ao atualizar favoritos.");
        } finally {
            props.toggleLoading(false);
        }
    };

    async function getFinancingLine(){
       
           
            let value
            if (props.typeOfFinancing === 1 || props.typeOfFinancing === 0) {
                value = await GetGrantByIdAPI(props.id!, props.typeOfFinancing)
            } else {
                const fetch1 = await GetGrantByIdAPI(props.id, 0)
                const fetch2 = await GetGrantByIdAPI(props.id, 1)//
                if (fetch1 !== null || fetch1 !== undefined) {
                    value = fetch1;
                }
                if (fetch2 !== null && fetch2 !== undefined) {
                    value = fetch2;
                }
            }
           
          
            if (value && value.data) {
                // if(props.typeOfFinancing == 1){
                //    // setGrantRefundable(value.data)
                // }else{
                //     if(props.typeOfFinancing == 0){
                //         setGrantSubvention(value.data)
                //     }else{
                //         setGrants(value.data);
                //     }
                // }
                return value.data;
            } else {
                console.error("Nenhum dado encontrado para grants.");
            }
           

    }

    useEffect(() => {
        const getTaxByDescription = () => {
            const title = props.title;
            const text = props.description?.trim().split(/\m+/);
            let valueResult = "";
            let isSub = false;

            text.forEach((line: string) => {
                const lineToCompare = line.toLowerCase().trim();
                const lineToSet = line.trim();
                const firstIndex = lineToSet.indexOf(":");

                if (title?.toLowerCase().startsWith("subvenção")) {
                    isSub = true;
                    if (lineToCompare.startsWith("valores:")) {
                        valueResult = lineToSet.slice(firstIndex + 1);
                    }
                } else {
                    if (lineToCompare.startsWith("taxas:")) {
                        valueResult = lineToSet.slice(firstIndex + 1);
                    }
                }
            });

            setTax(valueResult);
        };

        if (props.description) {
            getTaxByDescription();
        }
    }, [props.description, props.title,]);


    // useEffect(() => {
    //     console.log("grants atualizado:", grants);
    //     if (grants) {
    //         console.log("Goal:", grants.Goal);
    //         console.log("Summary:", grants.Summary);
    //     }
    // }, [grants])

    const getStringType = () => {
        switch (props.typeOfFinancing) {
            case 0: {
                return "Subvenção"
            }
            case 1: {
                return "Reembolsável"
            }
            default: {
                return "Favorito"
            }
        }
    }
    return (
        <Card className="line-card m-1" bordered>
            <div className="card-header">
                <Tooltip title={props.title}>
                    <Text className="grants-title">{props.title}</Text>
                </Tooltip>
                <Button
                    type="text"
                    className="heart-icon"
                    onClick={updateFav}
                >
                    {props.isFav ? ( //favorite
                        <HeartFilled className="heart-icon-blue" />
                    ) : (
                        <HeartOutlined className="heart-icon-blue" />
                    )}
                </Button>
            </div>
            <Link
                to={`/grantsSearcher/grants/${props.id}`}
                state={{
                    typeOfFinancing: props.typeOfFinancing,
                    grants: {
                        title: props.title,
                        isFav: isFav,
                        beneficiaryTypes: props.beneficiaryTypes,
                        deadline: props.deadline,
                        description: props.description,
                        id: props.id,
                        status: props.status,
                        linkLearnMore: props.link
                    }
                }}>
                <div className="grants-description">
                    <Tooltip title={`${getStringType()} - ${props.bankName}`}>
                        <span className="grants-details">
                            {`${getStringType()} - ${props.bankName}`.length > 20
                                ? `${`${getStringType()} - ${props.bankName}`.substring(0, 20)}...`
                                : `${getStringType()} - ${props.bankName}`}
                        </span>
                    </Tooltip>
                </div>
                <div className="more-info">
                    <Button
                        className="color-blue"
                        type="link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={props.linkLearnMore}
                    >
                        Saiba mais...
                    </Button>
                </div>
            </Link >
        </Card>
    );
};

export default LinesCard;